import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { GridCards } from '../Section/GridCards'
import { FilterNew } from '../Components/Filters'
import { NotFound } from '../Components/NotFound'
import { StoreContextMain } from '../Context/StoreContextMain'
import { applyFilters, quitarAcentos } from '../Utils'


export const Secciones = () => {

    const {search, filtersContext } = useContext(StoreContextMain)
    const {filters, search : searchParam} = useParams()
    const [activeFilters, setActiveFilters] = useState({});

    useEffect(() => {

        let updatedFilters = { ...activeFilters };
        // Si hay filtros en la URL, los aplicamos
        // Si hay filtros en el contexto, los aplicamos
        if (filters) {
            updatedFilters = {
                ...updatedFilters,
                ...applyFilters(filters)
            };
        }

        // Si hay un parámetro de búsqueda, lo aplicamos
        if (searchParam === 'name' && search) {
            updatedFilters.name = quitarAcentos(search.trim());
        }
        
        // Si hay filtros en el contexto, los aplicamos
        if (filtersContext && typeof filtersContext === 'object') {
            Object.entries(filtersContext).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    // Normaliza cada valor dentro del array (quita acentos y pasa a minúsculas)
                    updatedFilters[key] = value.map(v => quitarAcentos(v.toLowerCase()));
                } else if (value) {
                    // Normaliza si el valor no es un array
                    updatedFilters[key] = quitarAcentos(value.toLowerCase());
                }
            });
        }

        // Limpieza de filtros vacíos o nulos
        const cleanedFilters = Object.fromEntries(
            Object.entries(updatedFilters).filter(([_, v]) => v != null && v !== '')
        );

        setActiveFilters(cleanedFilters);
            
        return () => setActiveFilters({});

      }, [filters, search, searchParam, filtersContext]);

  
    return (
        <div className='row '>
            <div className='d-flex justify-content-between'>
                {/* <FilterNew /> */}
            </div>
            
            <div className='col-12 '>
                <div className='mx-3 me-3'>
                    {
                        Object.keys(activeFilters).length === 0 && (
                            <NotFound
                                icon="🔍"
                                title="No se encontraron resultados"
                                message="Intenta realizar otra búsqueda o vuelve más tarde."
                            />
                        )
                    }
                    <GridCards
                        url={'list-products/'}
                        params = {activeFilters}
                        pagination={true}
                    />
                </div>
            </div>
        </div>
    )
}

